var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["box p-3", _vm.declaration.class] }, [
    _c("div", { staticClass: "details " }, [
      _c("h2", { staticClass: "fw-semibold m-0" }, [
        _vm._v(
          "\n                " +
            _vm._s(_vm._f("numberFormat")(_vm.declaration.count)) +
            "\n            "
        ),
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "title fw-semibold" }, [
        _vm._v(
          "\n                " +
            _vm._s(_vm.declaration.title) +
            "\n            "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }